import * as React from 'react';
import getStore from '../data/store/store';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import strings from 'owa-strings/owa-options-strings';
import SuggestedRepliesOptionState from '../data/store/schema/SuggestedRepliesOptionState';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { observer } from 'mobx-react';
import { OptionDescription, OptionsCheckbox } from 'owa-options-controls';
import { selectAction } from '../data/actions/suggestedRepliesOptionActions';

@observer
export default class SuggestedRepliesFull extends React.Component {
    render() {
        const optionStore: SuggestedRepliesOptionState = getStore();
        const userConfiguration: OwaUserConfiguration = getUserConfiguration();
        const userOptions: UserOptionsType = userConfiguration && userConfiguration.UserOptions;

        // Nothing to render if we can't retrieve user options.
        if (!userOptions) {
            return null;
        }

        // Check if we have a value stored in the local store.
        // If not, use backend value.
        const isEnabled: boolean = getFallbackValueIfNull(
            optionStore.isEnabled,
            userOptions.WebSuggestedRepliesEnabledForUser
        );

        return (
            <div>
                <OptionDescription>
                    {strings.options_mail_suggestedRepliesDescription}
                    &nbsp;
                </OptionDescription>
                <OptionsCheckbox
                    checked={isEnabled}
                    label={strings.options_mail_suggestedRepliesEnable}
                    onChange={this.toggleEnable}
                />
            </div>
        );
    }

    private toggleEnable(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) {
        selectAction(checked);
    }
}
